import {MaterialNode} from "#material/nodes/base/material/material-node"
import type {ShaderToRgbSockets} from "#material/nodes/converter/shader-to-rgb/definition"
import {shaderToRgbDefinition} from "#material/nodes/converter/shader-to-rgb/definition"
import type {CyclesEvaluator, ThreeEvaluator} from "#material/nodes/base/material/types/evaluators"
import type {CyclesReturns} from "#material/sockets/cycles"
import type {ThreeReturns} from "#material/sockets/three"
import {registerMaterialGraphNode} from "#material/register"

@registerMaterialGraphNode
export class ShaderToRgb extends MaterialNode<ShaderToRgbSockets> {
    public override get definition() {
        return shaderToRgbDefinition
    }

    override toThree = async (evaluator: ThreeEvaluator): Promise<ThreeReturns<ShaderToRgbSockets>> => {
        throw new Error("Three support for ShaderToRgb is not implemented.")
    }

    override toCycles = async (evaluator: CyclesEvaluator): Promise<CyclesReturns<ShaderToRgbSockets>> => {
        throw new Error("ShaderToRgb does not support Cycles evaluation (only supported in EEVEE)")
    }
}
